/**
 * @mktvibe/kpis — contrato do emissor de eventos de KPI (F1-006).
 *
 * O emissor e a **unica** porta de saida de eventos de produto. Backend
 * e frontend invocam `emit(event)`; a implementacao decide se buffer
 * em memoria (dev/test), grava em stdout estruturado (primeira fase de
 * producao), ou envia para provedor de analytics (F3+).
 *
 * Regra dura: nao existe emissao ad-hoc. Lint (configurado em outro
 * item do backlog) bloqueara imports diretos para SDKs de analytics
 * fora deste package.
 */
/**
 * Valida invariantes minimas de todo evento antes de delegar. Util
 * para compartilhar entre implementacoes concretas.
 */
export function validateKpiEvent(event) {
    if (!event.tenant_id || typeof event.tenant_id !== 'string') {
        throw new Error('KpiEvent.tenant_id e obrigatorio e deve ser string nao vazia');
    }
    if (!event.occurred_at || typeof event.occurred_at !== 'string') {
        throw new Error('KpiEvent.occurred_at e obrigatorio (ISO-8601 UTC)');
    }
    // Sanity: occurred_at parseavel como Date valida.
    const ts = Date.parse(event.occurred_at);
    if (Number.isNaN(ts)) {
        throw new Error(`KpiEvent.occurred_at nao e ISO-8601 valido: ${event.occurred_at}`);
    }
    if (event.type === 'NPSRecorded') {
        if (event.score < 0 || event.score > 10 || !Number.isFinite(event.score)) {
            throw new Error(`NPSRecorded.score deve estar em [0..10]; recebido: ${event.score}`);
        }
    }
}
//# sourceMappingURL=emitter.js.map